export const makeDefaultPattern = (series, activeType, dimensionInfo) => {
    var _a, _b;
    return null !== (_b = null === (_a = series.tooltipHelper) || void 0 === _a ? void 0 : _a.getDefaultTooltipPattern(activeType, dimensionInfo)) && void 0 !== _b ? _b : null;
};
//# sourceMappingURL=pattern.js.map
